import React, { useState, useEffect } from "react";
import "./ActionUsers.css";
import { ImCross } from "react-icons/im";
import { ChatState } from "../../assets/context";
import { ENDPOINT } from "../../assets/endpoint";
import MessageLoader from "../../assets/MessageLoader"
import axios from "axios";
function ActionUser() {
  const { setActionMembers, ActionMembers } = ChatState();
  const [likedUsers, setLikedusers] = useState([]);
  const[Loading,setLoading] = useState(true)
const[ActionHead,setActionHead] = useState()
  const postedData = async () => {
    try {
      if (ActionMembers.for === "Like") {
        ActionMembers.DATA.likes.map(async (elem, i) => {
          const { data } = await axios.post(`${ENDPOINT}/user/whopost`, {
            id: ActionMembers.DATA.likes[i],
          });
          setActionHead("Likes")
          setLikedusers((current) => [...current, data]);
          setLoading(false)
        });
      }else if(ActionMembers.for === "followers"){
        ActionMembers.DATA.followers.map(async (elem, i) => {
            const { data } = await axios.post(`${ENDPOINT}/user/whopost`, {
              id: ActionMembers.DATA.followers[i],
            });
            setActionHead("Followers")
            setLikedusers((current) => [...current, data]);
            setLoading(false)
          });
      }else if(ActionMembers.for === "following"){
        ActionMembers.DATA.following.map(async (elem, i) => {
            const { data } = await axios.post(`${ENDPOINT}/user/whopost`, {
              id: ActionMembers.DATA.following[i],
            });
            setActionHead("Following")
            setLikedusers((current) => [...current, data]);
            setLoading(false)
          });
      }else if(ActionMembers.for === "comments"){
        setLikedusers( ActionMembers.DATA);
        setActionHead("Comments")
        setLoading(false)
      }else if(ActionMembers.for === "chatIMG"){
        setActionHead("PHOTO")
        setLoading(false)
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    postedData();
  }, [ActionMembers]);
  return (
    <>


    
      <div className="ActionUsers_main_box">
        <div className="ActionUsers_innerbox">
        {Loading?(
<MessageLoader/>
    ):(
         <>
          <div className="ActionUsers_head">
            <h3>{ActionHead}</h3>
            <ImCross onClick={() => setActionMembers({ type: false })} />
          </div>
       {
        ActionMembers.for === "chatIMG"?(
          <div className="ActionUsers_members">
       
           <img src={ActionMembers.DATA} style={{height:"100%",width:"auto"}} alt="amg" />
      
      </div>
        ):(
          ActionMembers.for === "comments"?(
            <div className="ActionUsers_members">
            {likedUsers.map((elem) => {
              return (
                <div className="action_member" key={elem._id}>
                {/* <img src={elem.profilePicture} alt="I" /> */}
                <div className="members_name" style={{display:"flex",justifyContent:"space-around",alignItems:"center",width:"100%"}}>
                  <h3 style={{fontSize:"10px"}}>{elem.username} :</h3>
                  <h5>{elem.comment}</h5>
                </div>
              </div>
            );
          })}
        </div>
          ):(
            <div className="ActionUsers_members">
            {!likedUsers? <MessageLoader/> :likedUsers.map((elem) => {
              return (
                <div className="action_member" key={elem._id}>
                  <img src={elem.profilePicture} alt="I" />
                  <div className="members_name">
                    <h3>{elem.username}</h3>
                    <h5>{elem.firstname + " " + elem.lastname}</h5>
                  </div>
                </div>
              );
            })}
          </div>
          )
        )
      }
         </>
      )}
        </div>
      </div>
    </>
  );
}

export default ActionUser;




